import React from "react";

function EventInfo() {
  return (
    <div className="flex flex-col j-c-center a-i-center gap-15 m-b-25">
      <div className="text-center">
        <p className="font-bold m-b-5 text-gold">Date & Time</p>
        <p>27th September 2024, 5:00pm</p>
      </div>

      <div className="text-center">
        <p className="font-bold m-b-5 text-gold">Venue</p>
        <p>One World Hotel, Petaling Jaya</p>
      </div>

      <div className="text-center">
        <p className="font-bold m-b-5 text-gold">Theme</p>
        <p>Red & Black Spanish Flamenco</p>
      </div>
    </div>
  );
}

export default EventInfo;
